import { render } from "./dashboardReviews.vue?vue&type=template&id=04c62191&scoped=true"
import script from "./dashboardReviews.vue?vue&type=script&lang=js"
export * from "./dashboardReviews.vue?vue&type=script&lang=js"

import "./dashboardReviews.vue?vue&type=style&index=0&id=04c62191&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c62191"]])

export default __exports__